import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { saveUserData } from "./termLifeSlice"
// import { resetDreamGoalData } from "./dreamGoalSlice"
// import { resetTermLifeData } from "@/store/slices/termLifeSlice.js";
// import { clearAddOns } from "@/store/slices/addOnsSlice.js";
// Thunk action to handle signup response and dispatch to both slices
export const handleSignupResponse = createAsyncThunk(
  "auth/handleSignupResponse",
  async (signupResponse, { dispatch }) => {
    console.log("🔄 AuthSlice: handleSignupResponse Thunk called with Data =>", signupResponse);


    // Dispatch to termLife userData for form population and token storage
    // dispatch(saveUserData(signupResponse)) //Donot perform redundant dispatch here 
    // console.log("✅ Auth: Dispatched saveUserData to termLife slice");

    return signupResponse
  }
)

// Async thunk for login
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (credentials, { rejectWithValue }) => {
    try {
      const { authService } = await import("../../services/authService");
      const response = await authService.login(credentials);

      if (response.status && response.data) {
        // Store token in localStorage
        if (response.accessToken) {
          localStorage.setItem('token', response.accessToken);
          console.log("Got Token from login response & stored in localStorage");
        }
        console.log("FROM AUTHSLICE ASYNCTHUNK:Login successful! Login Resonse => ", response);
        return response;
      }

      throw new Error('Invalid response from server');
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Login failed');
    }
  }
)

// Async thunk for registration
export const registerUser = createAsyncThunk(
  "auth/registerUser",
  async ({ userData, otp_id, otp }, { rejectWithValue }) => {
    try {
      console.log("🔐 RegisterUser Thunk - userData received:", userData);
      console.log("🔐 RegisterUser Thunk - ocrData in userData:", userData?.ocrData);
      const { authService } = await import("../../services/authService");
      const response = await authService.register(userData, otp_id, otp);

      if (response.status && response.data) {
        // Store token in localStorage
        console.log("Response inside Register Thunk From AuthService: ", response)
        if (response.accessToken) {
          localStorage.setItem('token', response.accessToken);
          console.log("Got Token from registration response & stored in localStorage", response.accessToken);
        } else {
          console.warn("No access token found in registration response");
        }
        return response;
      }

      throw new Error('Invalid response from server');
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Registration failed');
    }
  }
)

// Async thunk for token validation
export const validateToken = createAsyncThunk(
  "auth/validateToken",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.log("Form validatetoken thunk : No Token Found ")
        throw new Error('No token found');
      }

      const { authService } = await import("../../services/authService");
      const response = await authService.validateToken(token);
      console.log("FROM ValidateToken ASYNCTHUNK: Token validation successful! Response => ", response.data);
      return response;
    } catch (error) {
      localStorage.removeItem('token');
      localStorage.removeItem('efu_session_data');
      return rejectWithValue(error.response?.data?.message || error.message || 'Token validation failed');
    }
  }
);

// Async Logout thunk
export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const { authService } = await import("../../services/authService");
      await authService.logout();

      // Import and dispatch reset actions
      const { resetTermLifeData } = await import("@/store/slices/termLifeSlice.js");
      const { clearAddOns } = await import("@/store/slices/addOnsSlice.js");
      const { resetDreamGoalData } = await import("./dreamGoalSlice");
      const { resetMukamalSehatData } = await import("@/store/slices/mukamalSehatSlice.js");


      dispatch(resetTermLifeData());
      dispatch(clearAddOns());
      dispatch(resetDreamGoalData());
      dispatch(resetMukamalSehatData());

    } catch (error) {
      console.warn("Logout error at logoutUser Thunk :", error);
    }
    // Always clear state regardless of API call success
    return true;
  }
);
// Async thunk for sending OTP during Registeration
export const sendSignUpOtp = createAsyncThunk("auth/sendSignUpOtp",
  async ({ msisdn, email, cnic }, { rejectWithValue }) => {
    try {
      const { authService } = await import("../../services/authService");
      const response = await authService.sendSignUpOtp(msisdn, email, cnic);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to send OTP');
    }
  }
)
// Async thunk for forgot password
export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (mobile, { rejectWithValue }) => {
    try {
      const { authService } = await import("../../services/authService");
      const response = await authService.forgotPassword(mobile);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to send reset code');
    }
  }
)

// Async thunk for OTP verification
export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async ({ mobile, otp }, { rejectWithValue }) => {
    try {
      const { authService } = await import("../../services/authService");
      const response = await authService.verifyOtp(mobile, otp);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'OTP verification failed');
    }
  }
)

// Async thunk for setting new password
export const setNewPassword = createAsyncThunk(
  "auth/setNewPassword",
  async ({ msisdn, password, otp }, { rejectWithValue }) => {
    try {
      const { authService } = await import("../../services/authService");
      const response = await authService.setNewPassword(msisdn, password, otp);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to set new password');
    }
  }
)

// Async thunk for profile update
export const updateProfile = createAsyncThunk(
  "auth/updateProfile",
  async (profileData, { rejectWithValue }) => {
    try {
      const { authService } = await import("../../services/authService");
      const response = await authService.updateProfile(profileData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Profile update failed');
    }
  }
)

// Async thunk for refreshing user data
export const refreshUser = createAsyncThunk(
  "auth/refreshUser",
  async (_, { rejectWithValue }) => {
    try {
      const { authService } = await import("../../services/authService");
      const response = await authService.getCurrentUser();

      if (response.success && response.data) {
        return response;
      }

      throw new Error('Failed to refresh user data');
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to refresh user data');
    }
  }
)
const initialState = {
  user: null,
  isAuthenticated: false,
  loading: false,
  initializing: true, // Track if app is still checking auth status
  error: null,
  token: localStorage.getItem('token') || null,
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setUser: (state, action) => {
      state.user = action.payload
      state.isAuthenticated = !!action.payload
    },
    setToken: (state, action) => {
      state.token = action.payload
      if (action.payload) {
        localStorage.setItem('token', action.payload);
      } else {
        localStorage.removeItem('token');
      }
    },
    setSignupResponse: (state, action) => {
      // Save signup response to auth state
      state.user = action.payload?.data || action.payload
      state.isAuthenticated = !!action.payload?.data || !!action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    clearError: (state) => {
      state.error = null
    },
    logout: (state) => {
      state.user = null
      state.isAuthenticated = false
      state.token = null
      state.error = null
      localStorage.removeItem('token')
      localStorage.removeItem('efu_session_data')
    },
    restoreSession: (state, action) => {
      if (action.payload && action.payload.user) {
        state.user = action.payload.user
        state.isAuthenticated = true
      }
      state.initializing = false
    },
    setInitialized: (state) => {
      state.initializing = false
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle signup response
      .addCase(handleSignupResponse.fulfilled, (state, action) => {
        state.user = action.payload?.data || action.payload
        state.isAuthenticated = !!action.payload?.data || !!action.payload
        state.token = action.payload?.accessToken || null
      })
      .addCase(handleSignupResponse.rejected, (state, action) => {
        state.error = action.error.message
      })

      // Handle login
      .addCase(loginUser.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false
        const { role, data, accessToken } = action.payload;
        state.user = { ...data, role };  // spread data, add role
        state.token = accessToken;       // if you're storing token in redux
        state.isAuthenticated = true
        state.error = null

        // show the lucky draw popup once on the dashboard after every login
        sessionStorage.setItem('trigger_lucky_draw_popup', 'true');

        // trigger popup on next page load if verification is 0
        if (data?.nadra_verification === 0 || data?.nadra_verification === "0") {
          sessionStorage.setItem('trigger_biometric_popup', 'true');
        }
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.isAuthenticated = false
        state.user = null
      })

      // Handle registration
      .addCase(registerUser.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false
        const { role, data, accessToken } = action.payload;
        state.user = { ...data, role };  // spread data, add role
        // state.user = action.payload
        state.token = accessToken;       // if you're storing token in redux
        state.isAuthenticated = true
        state.error = null
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Handle SignUp OTP
      .addCase(sendSignUpOtp.pending, (state) => {
        state.loading = true
      })
      .addCase(sendSignUpOtp.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
      })
      .addCase(sendSignUpOtp.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Handle token validation
      .addCase(validateToken.pending, (state) => {
        state.loading = true
      })
      .addCase(validateToken.fulfilled, (state, action) => {
        state.loading = false
        state.initializing = false
        const { role, data } = action.payload;
        state.user = { ...data, role };  // spread data, add role
        state.token = localStorage.getItem('token'); // ensure token is in sync
        state.isAuthenticated = true
        state.error = null
      })
      .addCase(validateToken.rejected, (state, action) => {
        console.log("Token validation failed inside authSlice: ", action.payload);
        state.loading = false;
        state.initializing = false;
        // Don't immediately clear - let API interceptor try refresh first
        // Only clear if this was already a retry attempt
        if (action.meta?.isRetry) {
          state.isAuthenticated = false;
          state.user = null;
          state.token = null;
          state.error = "Session validation failed. Please login again.";
          localStorage.removeItem('token');
          localStorage.removeItem('efu_session_data');
        }

      })
      // Handle forgot password
      .addCase(forgotPassword.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
        // Don't update user state for forgot password
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Handle OTP verification
      .addCase(verifyOtp.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
        // OTP verification successful - ready for password reset
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Handle set new password
      .addCase(setNewPassword.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(setNewPassword.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
        // Password reset successful
      })
      .addCase(setNewPassword.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Handle profile update
      .addCase(updateProfile.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.loading = false
        state.user = { ...state.user, ...action.payload }
        state.error = null
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Handle refresh user
      .addCase(refreshUser.pending, (state) => {
        // Don't set loading to true for refresh - it should be silent
        state.error = null
      })
      .addCase(refreshUser.fulfilled, (state, action) => {
        const { role, data } = action.payload;
        state.user = { ...data, role };  // Update user with fresh data
        state.isAuthenticated = true
        state.error = null
      })
      .addCase(refreshUser.rejected, (state, action) => {
        // Log error but don't affect UI state - refresh should be silent
        console.warn('User refresh failed:', action.payload);
        state.error = null; // Don't show error to user for background refresh
      })

      // Handle logout
      .addCase(logoutUser.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(logoutUser.fulfilled, (state) => {

        state.loading = false
        state.user = null
        state.isAuthenticated = false
        state.token = null
        state.error = null
        localStorage.removeItem('token')
        localStorage.removeItem('efu_session_data')

      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.loading = false
        // Even if logout fails on server, clear local state
        state.user = null
        state.isAuthenticated = false
        state.token = null
        state.error = null
        localStorage.removeItem('token')
        localStorage.removeItem('efu_session_data')
      })
  },
})

export const {
  setLoading,
  setUser,
  setToken,
  setSignupResponse,
  setError,
  clearError,
  logout,
  restoreSession,
  setInitialized,
} = authSlice.actions

export default authSlice.reducer